export const isEmailAddress = (email: string): boolean => {
  const reg = email.match(/.+@.+\..+/);
  if (reg !== null) {
    return true;
  } else {
    return false;
  }
};

export const isZenkakuKana = (str: string) => {
  // eslint-disable-next-line no-irregular-whitespace
  const reg = str.match(/^[ァ-ヶー　]+$/);
  if (reg !== null) {
    return true;
  } else {
    return false;
  }
};

export const isURL = (url: string) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return !!pattern.test(url);
};
